<!-- @Version: 1.0.3 -->
@if (done$$() == true) {
  <div data-testid="textInputContainer" [formGroup]="fgText" class="row">
    <mat-form-field data-width="100%" [hideRequiredMarker]="hideRequireMaker" >
      @if (fieldItem.attribute_1 && fieldItem.attribute_1 != '') {
        <mat-label data-testid="label" [innerHTML]="fieldItem.attribute_1!"></mat-label>
      }
      <textarea  cdkTextareaAutosize #autosize="cdkTextareaAutosize" class="textarea-fake" data-testid="input" matInput [required]="fieldItem.required! && !fgText.get(FC_TEXT_INPUT.TEXT)?.disabled"  [formControlName]="FC_TEXT_INPUT.TEXT" [placeholder]="fieldItem.placeholder ?? ''"></textarea>
      @if (fgText.get(FC_TEXT_INPUT.TEXT)?.hasError(VALIDATORS.pattern)) {
        <mat-error data-testid="errorPattern" [innerHTML]="errorCodes.errorCodePattern"></mat-error>
      }
      @else if (fgText.get(FC_TEXT_INPUT.TEXT)?.hasError(VALIDATORS.max) && fgText.get(FC_TEXT_INPUT.TEXT)?.touched ) {
        <mat-error data-testid="errorMaxSize" [innerHTML]="errorCodes.errorCodeMaxSize"></mat-error>
      }
      @else if (fgText.get(FC_TEXT_INPUT.TEXT)?.hasError(VALIDATORS.min) && fgText.get(FC_TEXT_INPUT.TEXT)?.touched ) {
        <mat-error data-testid="errorMinSize" [innerHTML]="errorCodes.errorCodeMinSize"></mat-error>
      }
      @else if (fgText.get(FC_TEXT_INPUT.TEXT)?.hasError(VALIDATORS.required) && fgText.get(FC_TEXT_INPUT.TEXT)?.touched ) {
        <mat-error data-testid="errorRequired" [innerHTML]="errorCodes.errorCodeRequired"></mat-error>
      }
    </mat-form-field>
  </div>
}
